import script from "./SvVerticalTabs.vue?vue&type=script&setup=true&lang=ts"
export * from "./SvVerticalTabs.vue?vue&type=script&setup=true&lang=ts"

import "./SvVerticalTabs.vue?vue&type=style&index=0&id=008db79c&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.3.1_vue@3.3.7_typescript@4.9.5__webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-008db79c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../node_modules/.pnpm/@quasar+app-webpack@3.11.3__19fadae530b491e33818dbf1a8400ef1/node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QTabs,QTab,QTabPanels,QTabPanel});
